import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  screenConfigsList: [],
  currentScreenConfig: {},
  trades: [],
  workOrderTypes: [],
  company: null
}

const slice = createSlice({
  name: 'data',
  initialState,
  reducers: {
    setScreenConfigsList (state, action) {
      state.screenConfigsList = action.payload
    },
    setCurrentScreenConfig (state, action) {
      state.currentScreenConfig = action.payload
    },
    setTrades (state, action) {
      state.trades = action.payload
    },
    setWorkOrderTypes (state, action) {
      state.workOrderTypes = action.payload
    },
    setCompanyData (state, action) {
      state.company = action.payload
    },
    logout (state) {
      state.company = null
      state.screenConfigsList = []
    }
  }
})

export const dataActions = slice.actions

export default slice.reducer
